import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { axios } from 'utils/axios';

export type ReadIds = {
  readIds: string[];
};

export const fetchReadIds = async (): Promise<ReadIds> => {
  const { data } = await axios.get('read-state/ids');
  return data;
};

export const useReadIds = (): UseQueryResult<ReadIds> => {
  return useQuery({
    queryKey: ['read-state'],
    queryFn: fetchReadIds,
    // Without this, staleTime defaults to 0 — every mounted read indicator
    // (ArticleHeroDesktop, list rows, etc.) would treat the cached list as
    // stale and re-fetch in the background. useMarkAsRead/useUnmarkAsRead
    // already patch this cache directly on success (see markAsRead.ts /
    // unmarkAsRead.ts), so a mark/unmark still reflects immediately
    // everywhere — staleTime only suppresses redundant background refetches
    // on mount.
    staleTime: 5 * 60 * 1000,
  });
};
